import React from 'react';
import classNames from 'classnames';
import style from './App.less';

import { injectIntl } from 'react-intl';
import { inject, toggleInject } from "../components/injector";


class Error1 extends React.PureComponent {
    componentDidMount() {
        document.title = this.props.intl.formatMessage({ id: 'faultTitle' })
    }

    strs = (id) => {
        const { formatMessage } = this.props.intl;
        const data = formatMessage({ id: id });
        return data.replace(/(\r\n)|(\n)/g, '<br/>');
    };

    render() {
        const { pwr, intl, history,isZx } = this.props;
        return (
            <div className={style.errorPage}>
                <div className={style.errorTitle}>{intl.formatMessage({ id: 'error1Title' })}</div>
                <div className={style.errorContent}>
                    <div className={style.errorDesc}>{intl.formatMessage({ id: 'error1desc' })}</div>
                    <table>
                        <tbody>
                            <tr>
                                <td>{intl.formatMessage({ id: 'errorReason' })}</td>
                                <td>{intl.formatMessage({ id: 'resolvent' })}</td>
                            </tr>
                            <tr>
                                <td>{intl.formatMessage({ id: 'error1A' })}</td>
                                <td>{intl.formatMessage({ id: 'error1AMethod' })}</td>
                            </tr>
                            <tr>
                                <td>{intl.formatMessage({ id: 'error1B' })}</td>
                                <td>{intl.formatMessage({ id: 'error1BMethod' })}</td>
                            </tr>
                            <tr>
                                <td>{intl.formatMessage({ id: 'error1C' })}</td>
                                <td>{intl.formatMessage({ id: 'error1CMethod' })}</td>
                            </tr>
                            <tr>
                                <td>{intl.formatMessage({ id: 'error1D' })}</td>
                                <td>{intl.formatMessage({ id: 'error1DMethod' })}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

        )
    }
}



export default inject()(injectIntl(Error1));